var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPosition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    d: "M0 0h24v24H0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M19 11h2c.55 0 1 .44 1 1 0 .55-.45 1-1 1h-2c-.56 0-1-.45-1-1 0-.56.44-1 1-1ZM3 11h2c.55 0 1 .44 1 1 0 .55-.45 1-1 1H3c-.56 0-1-.45-1-1 0-.56.44-1 1-1Zm9-9c.55 0 1 .44 1 1v2c0 .55-.45 1-1 1 -.56 0-1-.45-1-1V3c0-.56.44-1 1-1Zm0 16c.55 0 1 .44 1 1v2c0 .55-.45 1-1 1 -.56 0-1-.45-1-1v-2c0-.56.44-1 1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    d: "M12 10a2 2 0 1 0 0 4 2 2 0 1 0 0-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17c2.76 0 5-2.24 5-5 0-2.77-2.24-5-5-5 -2.77 0-5 2.23-5 5 0 2.76 2.23 5 5 5Zm0 2c-3.87 0-7-3.14-7-7 0-3.87 3.13-7 7-7 3.86 0 7 3.13 7 7 0 3.86-3.14 7-7 7Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.3b69b7fe.svg";
export { ForwardRef as ReactComponent };